export function UserMealFormMealName({ form, updateField }) {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 mb-6">
      <label className="block text-sm font-medium text-gray-900 mb-2">
        Meal Name *
      </label>
      <input
        type="text"
        value={form.mealName}
        onChange={(e) => updateField("mealName", e.target.value)}
        placeholder="e.g., Grilled Salmon with Lemon"
        required
        className="w-full px-4 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent"
      />
    </div>
  );
}
